import { styled } from "@mui/material/styles"

export const List = styled("ul")({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  gap: "10px"
})
